import React from 'react';
export function SectionCTA() {
  const scrollToForm = (e: React.MouseEvent) => {
    e.preventDefault();
    const form = document.getElementById('register-form');
    if (form) {
      form.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  return <div className="text-center mt-12" data-id="element-135">
      <a href="#register-form" onClick={scrollToForm} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-brand-coral hover:bg-brand-coralHover rounded-full shadow-[0_8px_20px_-6px_rgba(232,97,74,0.5)] hover:shadow-[0_12px_24px_-8px_rgba(232,97,74,0.6)] hover:-translate-y-1 transition-all duration-300" data-id="element-136">
        Ja, ik meld me gratis aan!
      </a>
    </div>;
}